import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import DropDownButton from 'devextreme-react/drop-down-button';
import { useHtmlThemeMode } from '../theme/useHtmlThemeMode';
import { editorTabKindIcon } from './editorWorkspaceTabIcons';
import { workspaceHref } from './editorRoutes';
import { useEditorWorkspaceStore } from './useEditorWorkspaceStore';

type OpenFileRow = {
  id: string;
  text: string;
  icon: string;
};

export function EditorWorkspaceOpenFiles() {
  const navigate = useNavigate();
  const htmlTheme = useHtmlThemeMode();
  const tabs = useEditorWorkspaceStore((state) => state.tabs);
  const focusTab = useEditorWorkspaceStore((state) => state.focusTab);

  const items = useMemo(
    (): OpenFileRow[] =>
      tabs.map((tab) => ({
        id: tab.id,
        text: `${tab.dirty ? '● ' : ''}${tab.title}`,
        icon: editorTabKindIcon(tab.kind, tab.mediaKind)
      })),
    [tabs]
  );

  const onSelect = useCallback(
    (tabId: string) => {
      focusTab(tabId);
      navigate(workspaceHref(tabId));
    },
    [focusTab, navigate]
  );

  return (
    <DropDownButton
      key={`open-files-${htmlTheme}`}
      className="editor-workspace-tabs__open-files"
      icon="orderedlist"
      text={`Open Files (${tabs.length})`}
      stylingMode="text"
      hint="Open files"
      displayExpr="text"
      keyExpr="id"
      dropDownOptions={{ width: 280, showTitle: false }}
      items={items}
      onItemClick={(e) => {
        const id = e.itemData?.id;
        if (typeof id === 'string') onSelect(id);
      }}
    />
  );
}
